// (c) 2026 Owl Consultations. All rights reserved.
// Proprietary and confidential — licensed use only. Unauthorized use,
// copying, or distribution is prohibited and may be prosecuted.

/**
 * RX-PERF-4: skeleton placeholder rows for table bodies during a foreground load.
 * Render INSIDE <tbody> in place of the data rows — never in place of the table —
 * so headers, pager, toolbar and scroll position stay mounted while data arrives.
 * Column count must match the real row so the header widths don't jump.
 */
export default function SkeletonRows({ rows, cols }: { rows: number; cols: number }) {
  return (
    <>
      <style>{`@keyframes owlSkelPulse { 0%, 100% { opacity: .45 } 50% { opacity: 1 } }`}</style>
      {Array.from({ length: Math.max(1, rows) }).map((_, r) => (
        <tr key={`skel-${r}`} aria-hidden="true" style={{ borderBottom: '1px solid var(--color-border)' }}>
          {Array.from({ length: Math.max(1, cols) }).map((_, c) => (
            <td key={c} style={{ padding: '12px 14px' }}>
              <div style={{
                height: 12, borderRadius: 6,
                background: 'var(--color-surface-alt, #e5e7eb)',
                animation: 'owlSkelPulse 1.2s ease-in-out infinite',
                // Vary widths a little so it reads as content, not stripes.
                width: c === 0 ? 56 : `${55 + ((r * 7 + c * 13) % 30)}%`,
              }} />
            </td>
          ))}
        </tr>
      ))}
    </>
  )
}
